{
  "SEARCH": {
    "TABS": {
      "ALL": "Всички",
      "CONTACTS": "Контакти",
      "CONVERSATIONS": "Разговори",
      "MESSAGES": "Messages"
    },
    "SECTION": {
      "CONTACTS": "Контакти",
      "CONVERSATIONS": "Разговори",
      "MESSAGES": "Messages"
    },
    "VIEW_MORE": "View more",
    "LOAD_MORE": "Load more",
    "SEARCHING_DATA": "Searching",
    "LOADING_DATA": "Loading",
    "EMPTY_STATE": "No {item} found for query '{query}'",
    "EMPTY_STATE_FULL": "No results found for query '{query}'",
    "PLACEHOLDER_KEYBINDING": "/ to focus",
    "INPUT_PLACEHOLDER": "Search messages, contacts or conversations",
    "RECENT_MESSAGES": "Моите наскоро изпратени съобщения",
    "EMPTY_STATE_DEFAULT": "Search by conversation id, email, phone number, messages for better search results.",
    "BOT_LABEL": "Бот",
    "READ_MORE": "Read more",
    "WROTE": "wrote:",
    "FROM": "от",
    "EMAIL": "имейл",
    "EMAIL_SUBJECT": "тема"
  }
}
